/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * User Invite Status
 */
export enum UserInviteStatusEnum {
    NEW = 'new',
    SENT = 'sent',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
}